// import axios from 'axios/index'
import SQL from 'sql.js'

function createAssocArray (keys = [], values = []) {
  let resultArray = []
  for (let i = 0; i < values.length; i++) {
    let obj = {}
    for (let j = 0; j < keys.length; j++) {
      obj[keys[j]] = values[i][j]
    }
    resultArray.push(obj)
  }
  return (resultArray)
}

const state = {
  folders: {},
  allViews: {},
  cardId: 0,
  viewId: 0,
  maxLevels: 5,
  lastLearnRoute: {
    1: {},
    2: {},
    3: {},
    4: {},
    5: {}
  }
}

const getters = {
  getFolders (state) {
    return state.folders
  },
  getAllViews (state) {
    return state.allViews
  },
  getViewId (state) {
    return state.viewId
  },
  getCardId (state) {
    return state.cardId
  },
  getLastLearnRoute (state) {
    return state.lastLearnRoute
  }
}

const actions = {
  updateCurrentView ({ dispatch, state, commit }, data) {
    const viewCount = data.viewCount
    const currentLevel = data.currentLevel
    // console.log(typeof state.folders)
    // console.log(state.folders)
    Object.keys(state.folders).map(function (key, index) {
      // console.log('mapping level...', index)
      if (state.folders[index].level_number === currentLevel) {
        // console.log('Setting current level to ', currentLevel)
        commit('setLevelToActive', index)
      } else {
        commit('setLevelToInactive', index)
      }
    })
    console.log('updateCurrentView()', viewCount, currentLevel)
  },
  fetchAllLevelsWithViews ({dispatch, state, rootState, commit}, data) {
    if (Object.keys(state.folders).length === 0) {
      dispatch('connectDb', data.deckId, {root: true})
        .then(dbObject => {
          const db = new SQL.Database(dbObject)
          db.exec(`PRAGMA query_only = true;`)
          let viewCount = 1
          let allViews = []
          const maxLevels = state.maxLevels
          const query = `SELECT level_number, name from levels ORDER BY level_number ASC LIMIT 0,${maxLevels}`

          let levelContents = db.exec(query)
          const levels = createAssocArray(levelContents[0]['columns'], levelContents[0]['values'])
          let levelObj = []
          let lastLevel = 0
          levels.forEach((levelValue, levelIndex) => {
            let levelNumber = parseInt(levelValue.level_number)
            let viewsCountInLevel = 0
            if (data.level === levelNumber || data.level === 'all') {
              let folderContents = db.exec(`SELECT b.folder_id, b.name from level_folders a, folders b
        WHERE a.level_number = ${levelNumber} AND a.folder_id = b.folder_id`)
              const folders = createAssocArray(folderContents[0]['columns'], folderContents[0]['values'])
              let folderObj = []

              folders.forEach((folderValue, folderIndex) => {
                // console.log(':::1.FOLDER::::', folderValue['folder_id'], folderIndex)
                let cardContents = db.exec(`SELECT b.card_id, b.name, b.resource_id from cardtagfolder a, cards b
          WHERE a.folder_id = ${folderValue['folder_id']} AND a.card_id = b.card_id ORDER BY a.ordinal`)
                const cards = createAssocArray(cardContents[0]['columns'], cardContents[0]['values'])
                let cardObj = []
                let isLastCard = false
                cards.forEach((cardValue, cardIndex) => {
                  // console.log(':::2.CARD::::' + cardIndex, cardValue, cardIndex)
                  let viewContents = db.exec(`SELECT a.card_id, b.view_id, b.title FROM card_view a, views b
            WHERE a.view_id = b.view_id AND a.card_id = ${cardValue['card_id']}`)
                  const views = createAssocArray(viewContents[0]['columns'], viewContents[0]['values'])
                  let viewObj = []
                  let minViewCount = viewCount

                  isLastCard = cards.length - 1 === cardIndex

                  let isLastView = false
                  let nextLevel = 1
                  let previousLevel = 0

                  views.forEach((viewValue, viewIndex) => {
                    // console.log(':::3.VIEW::::' + viewIndex, viewValue)
                    if (isLastCard === true) {
                      isLastView = views.length - 1 === viewIndex
                    }

                    if (isLastView === true) {
                      nextLevel = levelNumber < levels.length ? levelNumber + 1 : 1
                    } else {
                      nextLevel = levelNumber
                    }

                    if (viewIndex === 0 && cardIndex === 0) {
                      previousLevel = lastLevel
                    } else {
                      previousLevel = levelNumber
                    }

                    let resourceContents = db.exec(`select resource_id, resource_type, caption, headers, image_name, extension, resourceurl, textcontent
                   FROM resources where view_id = ${viewValue['view_id']}`)
                    let resourceObj = createAssocArray(resourceContents[0]['columns'], resourceContents[0]['values'])
                    let textResource = resourceObj.find((resource) => resource.resource_type === 0)
                    let imageResource = resourceObj.find((resource) => resource.resource_type === 1)
                    viewsCountInLevel++
                    let myView = {
                      ...viewValue,
                      ...{ textResource: textResource },
                      ...{ imageResource: imageResource },
                      ...{ viewCount: viewCount++ },
                      ...{ level: levelNumber, previousLevel, nextLevel },
                      viewsCountInLevel
                    }
                    viewObj[viewIndex] = myView
                    allViews.push(myView)
                  })// views

                  let maxViewCount = viewCount - 1
                  cardObj[cardIndex] = { ...cardValue, ...{ views: viewObj }, ...{ minViewCount }, ...{ maxViewCount } }
                })// cards
                folderObj = [...folderObj, ...cardObj]
              })// folders
              levelObj[levelIndex] = {
                ...levelValue,
                ...{ cards: folderObj },
                ...{ isActive: false },
                viewsCountInLevel
              }
            } else { // end if
              levelObj[levelIndex] = levelValue
            }
            lastLevel++
          })
          commit('setFolders', levelObj)
          commit('setAllViews', allViews)
          // commit('setLoadingCourseDialog', {status: false, msg: ''}, { root: true })
        })
        .catch(err => {
          console.error('fetchAllLevelsWithViews', err)
        })
    }
  }
}

// mutations
const mutations = {
  setViewId (state, value) {
    state.viewId = value
  },

  setCardId (state, value) {
    state.cardId = value
  },

  setLevelToActive (state, data) {
    const viewCount = data.viewCount
    const currentLevel = data.currentLevel
    console.log(typeof state.folders)
    console.log(state.folders)
    Object.keys(state.folders).map(function (key, index) {
      console.log('mapping level...', index)
      if (state.folders[index].level_number === currentLevel) {
        console.log('Setting current level to ', currentLevel)
        state.folders[index].isActive = true
      } else {
        state.folders[index].isActive = false
      }
    })
    console.log('updateCurrentView()', viewCount, currentLevel)
  },

  setLevelToInactive (state, index) {
    // state.folders[index].isActive = false
  },

  setFolders (state, data) {
    state.folders = data
  },

  setAllViews (state, data) {
    state.allViews = data
  },

  setLastLearnRoute (state, data) {
    state.lastLearnRoute = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/learn.js